import {StorageKey} from "../../../../enums/StorageKey";
import {t} from "@lingui/macro";
import {AccountCell, AccountCodeCell} from "../../../../containers/AppPage/Reports/ChartOfAccounts/cell";
import React from "react";

function getColumns(props) {
    const { getSystemTypeChildren } = props;
    return [
        {
            title: t`Code`,
            dataIndex: 'code',
            key: 'code',
            onCell: record => ({
                colSpan: record.is_heading ? 6 : 1,
                className: record.is_heading ? 'report-heading-col' : null,
            }),
            render: (text, record) => <AccountCodeCell record={record} />,
        },
        {
            title: t`Account`,
            dataIndex: 'name',
            key: 'name',
            onCell: record => ({
                colSpan: record.is_heading ? 0 : 1,
            }),
            render: (text, record) => <AccountCell text={text} record={record} />,
        },
        {
            title: t`Currency`,
            dataIndex: 'currency_code',
            key: 'currency_code',
            onCell: record => ({
                colSpan: record.is_heading ? 0 : 1,
            }),
        },
        {
            title: t`System Account`,
            dataIndex: 'system_type',
            key: 'system_type',
            onCell: record => ({
                colSpan: record.is_heading ? 0 : 1,
            }),
            render: (value, record) => getSystemTypeChildren(record),
        },
    ];
}

export default {
    storageKey: StorageKey.report_chart_of_accounts,
    getReportLabel: () => t`Chart Of Accounts`,
    required: [
        'code',
        'name',
        'currency_code',
        'system_type',
    ],
    defaulto: [
    ],
    getColumns,
};
